module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"retrieve-password":"重置密码","password-resetting-method":"请选择以下重置密码的方式","use-mobile":"使用登录手机重置","use-email":"使用安全邮箱重置","use-question":"使用安全问题重置","unbound":"未进行任何绑定","document-title":"重置密码"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
